module.exports = __webpack_public_path__ + "static/img/case-zlj-page-bg-07.e0cd49c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case/zlj/case-zlj-page-bg-07.jpg
// module id = G4cG
// module chunks = 1